import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

interface IResponseErrorConfig {
  domain: string;
  message: string;
  details?: IErrorDetails;
}

export class ResponseError extends GenericError {
  public constructor(config: IResponseErrorConfig) {
    super({
      ...config,
      type: 'ResponseError',
    });
  }
}
